import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {Observable} from 'rxjs';
import {User} from '../interfaces/user.interface';

@Injectable({providedIn: 'root'})
export class UserService {

  constructor(private http: HttpService) {
  }

  getAll() {
    return this.http.get(`/user`);
  }

  /**
   * @description Login de usuario
   * @param data Email y Password
   */
  login(data: any): Observable<any> {
    return this.http.post('login', data);
  }

  register(user: User) {
    return this.http.post(`user`, user);
  }

  delete(id) {
    return this.http.delete(`users/${id}`);
  }


}
